//@vendor
const isEqual = require('lodash/lang/isEqual');
const get = require('lodash/object/get');
const moment = require('moment');
const { createActions } = require('redux-actions');
const { formatText } = require('core/i18n').i18n;
//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatAmount } = require('utilities/currencyHelper');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const download = require('downloadjs');
const BrowserUtils = require('utilities/browserUtils');
const { getIsKOxDTI, getTranslatedDocumentName, haveExpenses, downLoadDocumentInOtherPage } = require('../loansUtilities/loansHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const {
    PAGE_LOANS_MORTGAGES,
    PROC_STEP,
    PROC_FAIL,
    PROC_CONTRACT_PAYROLL_LOAN,
    recordProcess,
    recordLink
} = require('utilities/tagging');

//@constants
const {
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    WIZARD_FOURTH_STEP,
    WIZARD_FIFTH_STEP,
    ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEX,
    REGEX_REMOVE_SPECIAL_SYMBOLS
} = require('constants/index');
const {
    PERSONAL_LOAN_DRAGO,
    PRE_CONTRACTUAL_PAYROLL_LOAN_MAIL,
} = require('constants/flagBasedFeatures');
const {
    PAYROLL_LOAN_CRIBE_CONST,
    amortizationTypes,
    retailLoanCommons,
    contractEasyLoan: { PAYMENT_DAY_END_OF_MONTH },
    payrollLoanCommon: { PRODUCT_TYPE, FINANCIADA, NO_FINANCIADA, ASNEFKO },
    payrollLoanErrorDocument: { NOM_VL, IRPF100, RECEIPT },
    payrollLoanRecordStatus: { requestStatus: { PRE_APPROVAL_OK, ERROR_DOCUMENTACION, DENEGADO_ANTES_PREAPROB } },
    payrollLoanTypeUpload: {
        IRPF_FILE,
        PAYROLL_LOAN_CERTIFICATE,
        ADITIONAL_EXPENSES_FILES,
        FILE_FIRST_INDEX,
    },
    payrollLoanDataPrecontractualEmail: {
        PRODUCT,
        STANDARD,
        SUBPRODUCT,
        TEMPLATE_CODE,
    },
    payrollLoanDataAsnef: {
        ASNEF_PRODUCT,
        ASNEF_STANDARD,
        ASNEF_SUBPRODUCT,
    },
    PAYROLL_LOAN_PRE_APPROVED_STATUS: {
        SERVICE_ERROR,
        DENIED
    },
    VERSION_2,

} = require('../loansConstants/index');
const { LOAN_CHECK_CIRBE_PERSONAL, NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const translationContractLoanPdfViewerINE = require("../components/contracts/contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");

//@actions
const notificationActions = require('actions/notifications');

// Actions in alphabetic order
const simpleActions = createActions(
    'PAYROLL_LOAN_REQUEST_ASNEF',
    'PAYROLL_LOAN_REQUEST_ASNEF_ERROR',
    'PAYROLL_LOAN_REQUEST_ASNEF_FAILURE',
    'PAYROLL_LOAN_REQUEST_ASNEF_SUCCESS',

    'PAYROLL_LOAN_REQUEST_AMOUNT_KOXDTI',
    'PAYROLL_LOAN_REQUEST_AMOUNT_KOXDTI_ERROR',
    'PAYROLL_LOAN_REQUEST_AMOUNT_KOXDTI_SUCCESS',

    'PAYROLL_LOAN_REQUEST_APPROVAL',
    'PAYROLL_LOAN_REQUEST_APPROVAL_APPROVED',
    'PAYROLL_LOAN_REQUEST_APPROVAL_ERROR',
    'PAYROLL_LOAN_REQUEST_APPROVAL_REJECTED',

    'PAYROLL_LOAN_REQUEST_APPROVAL_LETTER',
    'PAYROLL_LOAN_REQUEST_APPROVAL_LETTER_ERROR',
    'PAYROLL_LOAN_REQUEST_APPROVAL_LETTER_SUCCESS',

    'PAYROLL_LOAN_REQUEST_CLEAR_ERRORS_FILE',

    'PAYROLL_LOAN_REQUEST_EDIT_NAME_FILE',
    'PAYROLL_LOAN_REQUEST_EDIT_NAME_FILE_SUCCESS',
    'PAYROLL_LOAN_REQUEST_EDIT_NAME_FILE_ERROR',

    'PAYROLL_LOAN_REQUEST_GET_JOBS',
    'PAYROLL_LOAN_REQUEST_GET_JOBS_ERROR',
    'PAYROLL_LOAN_REQUEST_GET_JOBS_SUCCESS',

    'PAYROLL_LOAN_REQUEST_GET_LOANS_FOR_EXPENSES',
    'PAYROLL_LOAN_REQUEST_GET_LOANS_FOR_EXPENSES_ERROR',
    'PAYROLL_LOAN_REQUEST_GET_LOANS_FOR_EXPENSES_SUCCESS',

    'PAYROLL_LOAN_REQUEST_GET_PURPOSES',
    'PAYROLL_LOAN_REQUEST_GET_PURPOSES_ERROR',
    'PAYROLL_LOAN_REQUEST_GET_PURPOSES_SUCCESS',

    'PAYROLL_LOAN_REQUEST_GET_PERSONAL_INFO',
    'PAYROLL_LOAN_REQUEST_GET_PERSONAL_INFO_ERROR',
    'PAYROLL_LOAN_REQUEST_GET_PERSONAL_INFO_SUCCESS',

    'PAYROLL_LOAN_REQUEST_LOAD_FILES',
    'PAYROLL_LOAN_REQUEST_LOAD_FILES_ERROR',
    'PAYROLL_LOAN_REQUEST_LOAD_FILES_SUCCESS',

    'PAYROLL_LOAN_REQUEST_PROPOSITION',
    'PAYROLL_LOAN_REQUEST_PROPOSITION_ERROR',
    'PAYROLL_LOAN_REQUEST_PROPOSITION_SUCCESS',

    'PAYROLL_LOAN_REQUEST_INITIALIZE',
    'PAYROLL_LOAN_REQUEST_INITIALIZE_ERROR',
    'PAYROLL_LOAN_REQUEST_INITIALIZE_SUCCESS',

    'PAYROLL_LOAN_REQUEST_INSTALLMENT',
    'PAYROLL_LOAN_REQUEST_INSTALLMENT_ERROR',
    'PAYROLL_LOAN_REQUEST_INSTALLMENT_SUCCESS',

    'PAYROLL_LOAN_REQUEST_MIN_TERM',
    'PAYROLL_LOAN_REQUEST_MIN_TERM_ERROR',
    'PAYROLL_LOAN_REQUEST_MIN_TERM_SUCCESS',

    'PAYROLL_LOAN_REQUEST_RESET',
    'PAYROLL_LOAN_REQUEST_RESET_CHECKBOX_CIRBE',
    'PAYROLL_LOAN_REQUEST_RESET_MIN_TERM_MAX_AMOUNT',
    'PAYROLL_LOAN_REQUEST_RESET_STEP',

    'PAYROLL_LOAN_REQUEST_SAVE_IN_PROGRESS',
    'PAYROLL_LOAN_REQUEST_SAVE_IN_PROGRESS_ERROR',
    'PAYROLL_LOAN_REQUEST_SAVE_IN_PROGRESS_SUCCESS',

    'PAYROLL_LOAN_REQUEST_SENT_EMAIL_PRECONTRACTUAL',
    'PAYROLL_LOAN_REQUEST_SENT_EMAIL_PRECONTRACTUAL_ERROR',
    'PAYROLL_LOAN_REQUEST_SENT_EMAIL_PRECONTRACTUAL_SUCCESS',

    'PAYROLL_LOAN_REQUEST_DOWNLOAD_PRECONTRACTUAL_INE',
    'PAYROLL_LOAN_REQUEST_DOWNLOAD_PRECONTRACTUAL_INE_SUCCESS',
    'PAYROLL_LOAN_REQUEST_DOWNLOAD_PRECONTRACTUAL_INE_ERROR',


    'PAYROLL_LOAN_REQUEST_DOWNLOAD_INE',
    'PAYROLL_LOAN_REQUEST_DOWNLOAD_INE_SUCCESS',
    'PAYROLL_LOAN_REQUEST_DOWNLOAD_INE_ERROR',

    'PAYROLL_LOAN_REQUEST_SET_KOXDTI',
    'PAYROLL_LOAN_REQUEST_SET_KOXDTI_SUCCESS',

    'PAYROLL_LOAN_REQUEST_SET_AMOUNT',
    'PAYROLL_LOAN_REQUEST_SET_AMOUNT_KOXDTI',
    'PAYROLL_LOAN_REQUEST_SET_CIRBE_CHECK',
    'PAYROLL_LOAN_REQUEST_SET_CIVIL_STATUS',
    'PAYROLL_LOAN_REQUEST_SET_COLLECTIVE',
    'PAYROLL_LOAN_REQUEST_SET_COMPANY_MONTHS',
    'PAYROLL_LOAN_REQUEST_SET_COMPANY_YEARS',
    'PAYROLL_LOAN_REQUEST_SET_CONTRACT_TYPE',
    'PAYROLL_LOAN_REQUEST_SET_CREDIT_CARD',
    'PAYROLL_LOAN_REQUEST_SET_EMPLOYMENT_LEVEL',
    'PAYROLL_LOAN_REQUEST_SET_INCOME',
    'PAYROLL_LOAN_REQUEST_SET_JOB',
    'PAYROLL_LOAN_REQUEST_SET_NEW_JOB_TYPE',
    'PAYROLL_LOAN_REQUEST_SET_OUTCOME',
    'PAYROLL_LOAN_REQUEST_SET_PURPOSE',
    'PAYROLL_LOAN_REQUEST_SET_REGIME',
    'PAYROLL_LOAN_REQUEST_SET_SUBPURPOSE',
    'PAYROLL_LOAN_REQUEST_SET_TOTAL_SENORITY_FIELDS_DIRTY',
    'PAYROLL_LOAN_REQUEST_SET_SENORITY_FIELDS_DIRTY',
    'PAYROLL_LOAN_REQUEST_SET_TERM',
    'PAYROLL_LOAN_REQUEST_SET_TERM_KOXDTI',
    'PAYROLL_LOAN_REQUEST_SET_VISIBLE_STEP',
    'PAYROLL_LOAN_REQUEST_SET_WORKING_TIME_WRAPPER',
    'PAYROLL_LOAN_REQUEST_SET_WORKING_TIME_WRAPPER_FOCUS',

    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_DISABLE',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_ERROR',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_LOAD',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_INVALID_ERROR',

    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_REMOVE',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_REMOVE_ERROR',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_REMOVE_SUCCESS',

    'PAYROLL_LOAN_REQUEST_UPLOAD_START_CONFIRM',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_RESET',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_SUBMIT',
    'PAYROLL_LOAN_REQUEST_UPLOAD_FILE_SUCCESS',

    'PAYROLL_LOAN_REQUEST_FINISH_WITHOUT_UPLOAD',

    'PAYROLL_LOAN_REQUEST_VALIDATE_STEP',

    'PAYROLL_LOAN_REQUEST_RECOVERY_PROCESS_TYPE',
    'PAYROLL_LOAN_INIT_INE_SUCCESS',
    'PAYROLL_LOAN_READ_DOCUMENT',
    'GET_PAYROLL_LOAN_INE__DOCUMENT_SUCCESS',
    'GET_PAYROLL_LOAN_INE__DOCUMENT_ERROR',
    'PAYROLL_LOAN_INIT_INE_ERROR',
    'PAYROLL_LOAN_CHECK_BOX_CHECKED_DOCUMENT',
    'PAYROLL_LOAN_EMAIL_SUCCESS',
    'PAYROLL_LOAN_EMAIL_ERROR',
    'GET_CONTRACT_PAYROLL_LOAN_EXPEDIENT_INE_SUCCESS',
    'GET_CONTRACT_PAYROLL_LOAN_EXPEDIENT_INE_ERROR',
    'PAYROLL_LOAN_REQUEST_INITIALIZE_FLOW_SUCCESS',
    'PAYROLL_LOAN_REQUEST_CHECK_RADIO_BUTTON',
    'PAYROLL_LOAN_REQUEST_PRINT_DOCUMENT_OFFICE',


);

const messageUploadExternalErrorText = 'payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadExternalErrorText';
const messageDeleteOrChangeNameErrorText = 'payrollLoanDocumentsUpload-fileErrorText';

const splitPayrollLoan = (payrollLoanData) => {
    return typeof payrollLoanData === "string" ? parseInt(payrollLoanData.split(' ')[0]) : payrollLoanData;
}

const validateJobLevel = (jobType, jobLevel, newJobTypesList, employmentLevelList) => {
    if (!!jobLevel || newJobTypesList.length === 0 || employmentLevelList.size > 0) {
        return jobLevel;
    }

    let newJobType = newJobTypesList.find(innerJobType => innerJobType.value == jobType)
    return !!newJobType ? newJobType.jobLevel[0].key : ""
}

const validateContractType = (jobType, contractType, newJobTypesList, contractTypeList, jobLevelDrago) => {
    if (!!contractType || newJobTypesList.length === 0 || contractTypeList.size > 0 || !jobLevelDrago) {
        return contractType;
    }

    let newJobType = newJobTypesList.find(innerJobType => innerJobType.value == jobType)
    let newContractType = ""
    if (newJobType) {
        let newJobLevelList = newJobType.jobLevel.find(job => job.key === jobLevelDrago)
        if (!!newJobLevelList) {
            newContractType = newJobLevelList.contractType[0].key
        }
    }
    return newContractType
}
const payrollLoanSaveInProgress = (changeStatusINE) => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;
    const immLoans = getState().loans;

    const loansById = immLoans.get('byId');
    const informationLoans = immPayrollLoan.get('loans');
    let sumMortgage = immPayrollLoan.getIn(['outcome', 'mortgage']);
    let sumOtherLoanInstallments = immPayrollLoan.getIn(['outcome', 'others']);

    informationLoans.map(item => {
        const loanFullInfo = loansById.find(loan => loan.get('contractNumber') === item.get('newContractNumber'));
        if (loanFullInfo.get('isMortgage')) {
            sumMortgage += parseFloat(item.get('monthlyFee'));
        } else {
            sumOtherLoanInstallments += parseFloat(item.get('monthlyFee'));
        }
    });

    let companyMonths = splitPayrollLoan(immPayrollLoan.get('companyMonths'));
    let companyYears = splitPayrollLoan(immPayrollLoan.get('companyYears'));
    let totalSenorityMonths = splitPayrollLoan(immPayrollLoan.get('totalSenorityMonths'));
    let totalSenorityYears = splitPayrollLoan(immPayrollLoan.get('totalSenorityYears'));

    let newJobTypesList = immPayrollLoan.get("newJobTypesList").toJS();
    const employmentLevelList = immPayrollLoan.get("employmentLevelList");
    const contractTypeList = immPayrollLoan.get("contractTypeList");

    let jobTypeDrago = immPayrollLoan.get('newJobType');
    let jobLevelDrago = validateJobLevel(jobTypeDrago, immPayrollLoan.get('employmentLevel'), newJobTypesList, employmentLevelList);
    let contractTypeDrago = validateContractType(jobTypeDrago, immPayrollLoan.get('contractType'), newJobTypesList, contractTypeList, jobLevelDrago);

    const params = {
        query: {
            amount: immPayrollLoan.get('selectedAmount'),
            purpose: immPayrollLoan.get('selectedPurpose'),
            purposeDrago: immPayrollLoan.get('selectedPurposeDrago'),
            subPurposeDrago: immPayrollLoan.get('subpurposeDrago'),
            recordId: immPayrollLoan.get('recordId'),
            term: immPayrollLoan.get('selectedTerm'),
            userType: immPayrollLoan.get('userType'),
            confirmDocumentsNeeded: true,
            financialInformation: {
                additionalPayments: immPayrollLoan.getIn(['income', 'extra']),
                housingType: immPayrollLoan.get('regime'),
                jobSeniorityInMonths: (companyMonths || companyMonths === 0) ? companyMonths : null,
                jobSeniorityInYears: (companyYears || companyYears === 0) ? companyYears : null,
                jobType: immPayrollLoan.get('job'),
                mortgageFee: sumMortgage,
                maritalStatus: immPayrollLoan.get('civilStatus'),
                netIncome: immPayrollLoan.getIn(['income', 'amount']),
                numberOfCreditCards: immPayrollLoan.get('creditCards'),
                otherLoanInstallments: sumOtherLoanInstallments,
                rent: immPayrollLoan.getIn(['outcome', 'rent']),
                totalJobInMonths: (totalSenorityMonths || totalSenorityMonths === 0) ? totalSenorityMonths : null,
                totalJobInYears: (totalSenorityYears || totalSenorityYears === 0) ? totalSenorityYears : null,
                jobTypeDrago: jobTypeDrago,
                jobLevelDrago: jobLevelDrago,
                contractTypeDrago: contractTypeDrago,
                maritalStatusDrago: immPayrollLoan.get('maritalStatusDrago'),
                housingTypeDrago: immPayrollLoan.get('housingTypeDrago'),
            }
        }
    };

    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
    if (!isDragoFeature) {
        params.query.financialInformation.totalJobInYears = immPayrollLoan.get('yearsWorkingTime');
        params.query.financialInformation.totalJobInMonths = immPayrollLoan.get('monthsWorkingTime');
    }

    dispatch(simpleActions.payrollLoanRequestSaveInProgress());
    return APIPost({ dispatch, endpoint: 'payrollLoanSaveInProgress', params })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestSaveInProgressError({ error: response.error }));
            } else {
                throw response;
            }
        }).then(() => dispatch(simpleActions.payrollLoanRequestSaveInProgressSuccess(changeStatusINE)));
}

const setPurpose = (type, purpose) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
    recordLink(PAGE_LOANS_MORTGAGES, 'seleccionar proposito', purpose);
    dispatch(simpleActions.payrollLoanRequestSetPurpose({ type, purpose, isDragoFeature }));
    dispatch(payrollLoanSaveInProgress());
};

const setCivilStatus = (type, result) => dispatch => {
    const civilStatus = result.value;

    dispatch(simpleActions.payrollLoanRequestSetCivilStatus({ type, civilStatus }));
    dispatch(payrollLoanSaveInProgress());
};

const setCreditCard = result => dispatch => {
    const creditCards = result.value;

    dispatch(simpleActions.payrollLoanRequestSetCreditCard({ creditCards }));
    dispatch(payrollLoanSaveInProgress());
};

const setJob = job => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetJob({ job }));
    dispatch(payrollLoanSaveInProgress());
};

const setNewJobType = jobType => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetNewJobType({ jobType: jobType.value }));
    dispatch(payrollLoanSaveInProgress());
};

const setEmploymentLevel = employmentLevel => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetEmploymentLevel({ employmentLevel: employmentLevel.value }));
    dispatch(payrollLoanSaveInProgress());
};

const setContractType = contractType => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetContractType({ contractType: contractType.value }));
    dispatch(payrollLoanSaveInProgress());
};

const setIncome = income => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetIncome({ income }));
    dispatch(payrollLoanSaveInProgress());
};

const setOutcome = (outcome, save = true) => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetOutcome({ outcome }));
    if (save) {
        dispatch(payrollLoanSaveInProgress(false));
    }
};

const setCompanyMonths = (companyMonths, type, callSaveService) => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetCompanyMonths({
        type,
        companyMonths,
    }));
    if (callSaveService) {
        dispatch(payrollLoanSaveInProgress());
    }
}

const setWorkingTimeWrapper = (type, lastTypeOfTime) => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetWorkingTimeWrapper({
        type,
        lastTypeOfTime,
    }));
};

const setWorkingTimeWrapperFocus = type => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetWorkingTimeWrapperFocus({
        type,
    }));
};

const setCompanyYears = (companyYears, type, callSaveService) => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetCompanyYears({
        type,
        companyYears,
    }));
    if (callSaveService) {
        dispatch(payrollLoanSaveInProgress());
    }
};

const setRegime = (type, result) => dispatch => {
    const regime = result.value;

    dispatch(simpleActions.payrollLoanRequestSetRegime({ type, regime }));
    dispatch(payrollLoanSaveInProgress());
};

const setLoanAmount = selectedAmount => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetAmount(selectedAmount));
    dispatch(payrollLoanSaveInProgress());
};

const setLoanAmountKOxDTI = (selectedAmount) => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetAmountKoxdti(selectedAmount));
    dispatch(payrollLoanSaveInProgress());
};

const setLoanTerm = term => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetTerm(term));
    dispatch(payrollLoanSaveInProgress());
};

const setLoanTermKOxDTI = (term) => dispatch => {
    dispatch(simpleActions.payrollLoanRequestSetTermKoxdti(term));
    dispatch(payrollLoanSaveInProgress());
};

const resetStep = step => dispatch => {
    if (isEqual(step, WIZARD_THIRD_STEP)) {
        dispatch(simpleActions.payrollLoanRequestResetStep());
    }
};

const approvalLetter = () => (dispatch, getState) => {
    const params = {
        query: {
            recordId: getState().payrollLoanRequest.get('recordId')
        }
    };

    dispatch(simpleActions.payrollLoanRequestApprovalLetter());
    return APIGet({ dispatch, params, endpoint: 'payrollLoanLetterImage' }).then((response) => {
        dispatch(simpleActions.payrollLoanRequestApprovalLetterSuccess({ response: response.data }));
    }).catch(response => {
        if (!!response.error) {
            dispatch(simpleActions.payrollLoanRequestApprovalLetterError({ error: response.error }));
        } else {
            throw response;
        }
    });
}

const changeViewPreApprovalKOxDTI = (viewLayoutPreApprovalKOxDTI, visibleStep) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const response = {
        viewLayoutPreApprovalKOxDTI,
        visibleStep
    };

    dispatch(simpleActions.payrollLoanRequestSetKoxdti({ response }));
    if (isEqual(visibleStep, WIZARD_THIRD_STEP)) {
        dispatch(payrollLoanSaveInProgress()).then(() => {
            const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
            dispatch(simpleActions.payrollLoanRequestSetKoxdtiSuccess({ response, isDragoFeature }));
        });
    } else {
        dispatch(simpleActions.payrollLoanRequestSetKoxdtiSuccess({ response }));
    }
};

const sentPrecontractualEmail = (propositionAlta) => (dispatch, getState) => {
    dispatch(simpleActions.payrollLoanRequestSentEmailPrecontractual());
    const immPayrollLoan = getState().payrollLoanRequest;
    const comisionFinanciadaValue = immPayrollLoan.get('indCapson') === amortizationTypes.YES ?
        FINANCIADA : NO_FINANCIADA;

    const params = {
        query: {
            producto: PRODUCT,
            standard: STANDARD,
            subproducto: SUBPRODUCT,
            templateCode: TEMPLATE_CODE,
            hiringDocumentRequest: {
                amount: formatAmount(immPayrollLoan.get('selectedAmount'), 'es'),
                calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee'), 'es'),
                financedCommission: comisionFinanciadaValue,
                firstTime: true,
                dueDate: moment(get(propositionAlta, 'vencDate')).format(DATE_FORMAT_WITH_SLASHES),
                endOfMonth: immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
                productDuration: immPayrollLoan.get('selectedTerm').toString(),
                productType: PRODUCT_TYPE,
                propositionNumber: get(propositionAlta, 'propositionNumber').toString(),
                propositionContractNumber: get(propositionAlta, 'contractNumber'),
                tae: formatAmount(immPayrollLoan.get('tae'), 'es'),
                tin: formatAmount(immPayrollLoan.get('tin'), 'es'),
                year: get(propositionAlta, 'propositionYear'),
            }
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'sendPrecontractualDocumentMail',
        params
    })
        .then(() => {
            dispatch(simpleActions.payrollLoanRequestSentEmailPrecontractualSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestSentEmailPrecontractualError());
            } else {
                throw response;
            }
        });
}

const requestLoanApproval = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    if (immPayrollLoan.get('callServicePreApproval')) {
        let propService = 'payrollLoanApproval';
        let params = {
            query: {
                recordId: immPayrollLoan.get('recordId'),
            }
        };
        if (immPayrollLoan.get('stepCallPreApproval') === WIZARD_SECOND_STEP && immFlagBasedFeatures.get(LOAN_CHECK_CIRBE_PERSONAL)) {
            propService = 'payrollLoanApprovalAndCirbe';
            params = {
                query: {
                    acceptedText: formatText('payrollLoanRequestStepOne-payrollLoanRequestStepOne_labelCirbeCheckbox'),
                    notificationId: "",
                    productId: PAYROLL_LOAN_CRIBE_CONST,
                    recordId: immPayrollLoan.get('recordId'),
                }
            };

        }
        dispatch(simpleActions.payrollLoanRequestApproval());
        return APIPost({ dispatch, endpoint: propService, params })
            .then(response => {
                const status = response.preApprovalStatus || '';
                if (status === PRE_APPROVAL_OK) {
                    dispatch(simpleActions.payrollLoanRequestApprovalApproved({ response }));
                    dispatch(approvalLetter());
                    recordProcess(PROC_CONTRACT_PAYROLL_LOAN, PROC_STEP + WIZARD_THIRD_STEP, { idPreaprobPP: response.preApprovalReferenceId });
                } else if (getIsKOxDTI(status)) {
                    dispatch(simpleActions.payrollLoanRequestApprovalApproved({ response }));
                    recordProcess(PROC_CONTRACT_PAYROLL_LOAN, PROC_STEP + WIZARD_THIRD_STEP, { idPreaprobPP: response.preApprovalReferenceId });

                    if (immPayrollLoan.get('stepCallPreApproval') === WIZARD_SECOND_STEP ||
                        immPayrollLoan.get('stepCallPreApproval') === WIZARD_FIRST_STEP) {
                        dispatch(changeViewPreApprovalKOxDTI(true, WIZARD_FIRST_STEP));
                    }
                } else {
                    dispatch(simpleActions.payrollLoanRequestApprovalRejected());
                    recordProcess(PROC_CONTRACT_PAYROLL_LOAN, PROC_FAIL, { categoriaError: DENIED }, true);
                }
            }).catch(response => {
                if (!!response.error) {
                    const errorType = {
                        error: response.error,
                        errorCode: response.error.status,
                    }
                    dispatch(simpleActions.payrollLoanRequestApprovalError(errorType));
                    recordProcess(PROC_CONTRACT_PAYROLL_LOAN, PROC_FAIL, { categoriaError: SERVICE_ERROR }, true);
                } else {
                    throw response;
                }
            });
    }
};

const printApprovalLetter = (file, contentType) => {
    const data = [new Uint8Array(file)];
    const blobObject = new Blob(data, { type: contentType });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(blobObject);
    } else {
        const blobURL = window.URL.createObjectURL(blobObject);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const actionApprovalLetter = (action) => (dispatch, getState) => {
    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            recordId: getState().payrollLoanRequest.get('recordId')
        }
    };

    return APIGet({ dispatch, endpoint: 'payrollLoanLetter', params })
        .then(response => {
            if (action === 'print') {
                printApprovalLetter(response.xhr.response, response.type);
            } else {
                download(response.xhr.response, 'approvalLetter.pdf', 'application/pdf');
            }
        });
};

const getInstallment = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    const endOfMonth = immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const standardCode = endOfMonth ? immPayrollLoan.get('endOfMonthReferenceStandard') :
        immPayrollLoan.get('productStandard');

    const params = {
        query: {
            capIndicator: 'N',
            intIndicator: 'N',
            currency: immPayrollLoan.get('currency'),
            amount: immPayrollLoan.get('selectedAmount'),
            priceIndicator: 'E',
            term: immPayrollLoan.get('selectedTerm'),
            productType: PRODUCT_TYPE,
            product: immPayrollLoan.get('productType'),
            subProduct: immPayrollLoan.get('productSubType'),
            standardCode,
            openingCommission: immPayrollLoan.get("arrangementFee"),
            tin: immPayrollLoan.get('tin')
        }
    };

    dispatch(simpleActions.payrollLoanRequestInstallment());
    return APIGet({ dispatch, endpoint: 'payrollLoanInstallment', params })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestInstallmentSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestInstallmentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const loadFilesPersonalLoan = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;
    const params = {
        header: {
            version: VERSION_2
        },
        query: {
            recordId: immPayrollLoan.get('recordId')
        }
    };
    const recordId = immPayrollLoan.get('recordId');
    if (recordId) {
        APIGet({ dispatch, endpoint: 'payrollLoanDocumentsState', params })
            .then(response => {
                dispatch(simpleActions.payrollLoanRequestLoadFilesSuccess({ response }));
            }).catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.payrollLoanRequestLoadFilesError());
                } else {
                    throw response;
                }
            });
    } else {
        dispatch(getPayrollLoanExpedientINE())
            .then((response) => {
                const params = {
                    header: {
                        version: VERSION_2
                    },
                    query: {
                        recordId: response.expedientId
                    }
                };
                dispatch(simpleActions.payrollLoanRequestLoadFiles());
                APIGet({ dispatch, endpoint: 'payrollLoanDocumentsState', params })
                    .then(response => {
                        dispatch(simpleActions.payrollLoanRequestLoadFilesSuccess({ response }));
                    }).catch(response => {
                        if (!!response.error) {
                            dispatch(simpleActions.payrollLoanRequestLoadFilesError());
                        } else {
                            throw response;
                        }
                    });
            })

    }
}

const getPurposes = () => dispatch => {
    dispatch(simpleActions.payrollLoanRequestGetPurposes());
    APIGet({ dispatch, endpoint: 'payrollLoanGetPurposes' })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestGetPurposesSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestGetPurposesError());
            } else {
                throw response;
            }
        });
}

const getJobsInformation = () => dispatch => {
    dispatch(simpleActions.payrollLoanRequestGetJobs());
    APIGet({ dispatch, endpoint: 'payrollLoanGetJobsInfo' })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestGetJobsSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestGetJobsError());
            } else {
                throw response;
            }
        });
}

const initialize = (simulationToken, isDragoFeature) => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    let params = { query: {} };

    const initialized = immPayrollLoan.get('initialized');
    const isFetching = immPayrollLoan.get('isFetching');

    if (initialized || isFetching) {
        return;
    }

    if (!isEqual(simulationToken, '0')) {
        params = {
            query: {
                simulationToken
            }
        };
    }

    dispatch(simpleActions.payrollLoanRequestInitialize());
    return APIGet({ dispatch, endpoint: 'payrollLoanInitialize', params: params })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestInitializeSuccess({ response }));
            dispatch(loadFilesPersonalLoan());
            if (isDragoFeature) {
                dispatch(getPurposes());
                dispatch(getJobsInformation());
            }
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestInitializeError({ error: response.error }));
            } else {
                throw response;
            }
        });
};
const initializeFlow = (simulationToken, isDragoFeature) => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    let params = { query: {} };

    const initialized = immPayrollLoan.get('initialized');
    const isFetching = immPayrollLoan.get('isFetching');

    if (initialized || isFetching) {
        return;
    }

    if (!isEqual(simulationToken, '0')) {
        params = {
            query: {
                simulationToken
            }
        };
    }

    dispatch(simpleActions.payrollLoanRequestInitialize());
    return APIGet({ dispatch, endpoint: 'payrollLoanInitialize', params: params })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestInitializeFlowSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestInitializeError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getRemainingInfo = (propositions) => dispatch => {
    const params = {
        query: {
            anio: propositions.propositionYear,
            numeroPropuesta: propositions.propositionNumber
        }
    };

    const promises = [
        APIGet({
            dispatch,
            params,
            endpoint: 'contractEasyLoanAmortizationAmortization'
        }),
        APIGet({
            dispatch,
            params,
            endpoint: 'contractEasyLoanInitialData'
        })
    ];

    return Promise.all(promises).then(responses => {
        const response = {
            propositionNumber: propositions.propositionNumber,
            propositionYear: propositions.propositionYear,
            vencDate: propositions.vencDate,
            contractNumber: propositions.contractNumber,
            fechaFinCarencia: get(responses, '1.fechaFinCarencia'),
            loanDueDate: get(responses, '1.fechaVctoPrestamos'),
            fechaAmortiz: get(responses, '0.fechaAmortiz,'),
            productNumber: null
        };

        return dispatch(simpleActions.payrollLoanRequestPropositionSuccess({ response }));
    })
}

const getProposition = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    const isCollective = immPayrollLoan.get('isCollective');

    const productDetail = isCollective ? immPayrollLoan.getIn(['collectiveInformation', '0', 'productDetail']) : null;
    const codigodeestandar = immPayrollLoan.get('productStandard');
    const subtipodeproducto = isCollective ? productDetail.get('subType') : immPayrollLoan.get('productSubType');
    const tipodeproducto = isCollective ? productDetail.get('type') : immPayrollLoan.get('productType');

    const params = {
        query: {
            indCapson: immPayrollLoan.get('indCapson'),
            importePpta: {
                importe: immPayrollLoan.get('selectedAmount'),
                divisa: immPayrollLoan.get('currency')
            },
            plazoPpta: {
                numerodeunidades: immPayrollLoan.get('selectedTerm'),
                unidaddetiempo: 'M'
            },
            finalidadPpta: '99',
            tipoPreciosOpera: 'E',
            canalOperacion: 'RED',
            estandar: {
                codigodeestandar,
                subtipodeproducto: {
                    subtipodeproducto,
                    tipodeproducto: {
                        tipodeproducto
                    }
                }
            }
        }
    };

    dispatch(simpleActions.payrollLoanRequestProposition());
    return APIPost({ dispatch, endpoint: 'contractEasyLoanPropositionNumber', params })
        .then(response => {
            const propositionAlta = {
                vencDate: get(response, 'fechaVenci'),
                propositionNumber: get(response, 'propuesta.numerodepropuesta'),
                propositionYear: get(response, 'propuesta.anio'),
                contractNumber: get(response, 'contrato.numerodecontrato'),
                productNumber: get(response, 'contrato.producto')
            };

            const recordStatus = immPayrollLoan.get('preApprovalState');
            if (recordStatus === PRE_APPROVAL_OK) {
                const immFlagBasedFeatures = getState().flagBasedFeatures;
                if (immFlagBasedFeatures.get(PRE_CONTRACTUAL_PAYROLL_LOAN_MAIL)) {
                    dispatch(sentPrecontractualEmail(propositionAlta));
                }
            }

            return dispatch(getRemainingInfo(propositionAlta));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestPropositionError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const validateAmountKOxDTI = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    const params = {
        query: {
            maxInstallment: immPayrollLoan.get('maxInstallment'),
            tin: immPayrollLoan.get('tin'),
            selectedAmount: immPayrollLoan.get('selectedAmount')
        }
    };

    dispatch(simpleActions.payrollLoanRequestAmountKoxdti());
    return APIGet({ dispatch, endpoint: 'payrollLoanMinTerm', params })
        .then((response) => {
            dispatch(simpleActions.payrollLoanRequestAmountKoxdtiSuccess({ response }));
            dispatch(getInstallment());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestAmountKoxdtiError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getMinTerm = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    const params = {
        query: {
            maxInstallment: immPayrollLoan.get('maxInstallment'),
            tin: immPayrollLoan.get('tin'),
            selectedAmount: immPayrollLoan.get('selectedAmount')
        }
    };

    dispatch(simpleActions.payrollLoanRequestMinTerm());
    return APIGet({ dispatch, endpoint: 'payrollLoanMinTerm', params })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestMinTermSuccess({ response }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestMinTermError({ error: response.error }));
            }
        });
};

const downloadINEDocument = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;

    const proposition = immPayrollLoan.get('proposition');

    const comisionFinanciadaValue = immPayrollLoan.get('indCapson') === amortizationTypes.YES ?
        FINANCIADA : NO_FINANCIADA;

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: proposition.get('propositionYear'),
            calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee'), 'es'),
            financedCommission: comisionFinanciadaValue,
            productDuration: immPayrollLoan.get('selectedTerm').toString(),
            dueDate: moment(proposition.get('vencDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            amount: formatAmount(immPayrollLoan.get('selectedAmount'), 'es'),
            propositionContractNumber: proposition.get('contractNumber'),
            propositionNumber: proposition.get('propositionNumber').toString(),
            firstTime: true,
            tae: formatAmount(immPayrollLoan.get('tae'), 'es'),
            tin: formatAmount(immPayrollLoan.get('tin'), 'es'),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.payrollLoanRequestDownloadIne());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocument', params }).then(response => {
        if (isPrintOfficeMode()) {
            download(response.xhr.response, 'ine.pdf', 'application/pdf');
        } else {
            const content = get(response, 'xhr.response');
            downLoadDocumentInOtherPage(content);
        }
        dispatch(simpleActions.payrollLoanRequestDownloadIneSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.payrollLoanRequestDownloadIneError());
        });
};

const checkIfAllFilesWereUploaded = (errorFlow = false) => (dispatch, getState) => {
    const immUpload = getState().payrollLoanRequest.get('upload');
    const irpfFile = immUpload.getIn(['irpfFile', 'uploaded']);
    const payrollLoanCertificate = immUpload.getIn(['payrollLoanCertificate', 'uploaded']);

    if (irpfFile && payrollLoanCertificate) {
        const immPayrollLoanRequest = getState().payrollLoanRequest;
        const recordId = getState().loanRecordStatus.get('recordId')

        const documentsFlowIsEnable = immPayrollLoanRequest.get('enableDocumentsFlow');

        const params = {
            query: {
                loans: !errorFlow ? immPayrollLoanRequest.get('loans').toJS() : [],
                recordId: immPayrollLoanRequest.get('recordId') || recordId

            }
        }

        dispatch(simpleActions.payrollLoanRequestUploadStartConfirm());
        APIPost({ dispatch, endpoint: 'payrollLoanDocumentsConfirm', params })
            .then(() => {
                //dispatch action to enable success page
                dispatch(simpleActions.payrollLoanRequestUploadFileSubmit());
                dispatch(simpleActions.payrollLoanRequestUploadFileReset());

                if (documentsFlowIsEnable) {
                    dispatch(simpleActions.payrollLoanRequestUploadFileDisable());
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.payrollLoanRequestSaveInProgressError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }

}
const checkReadDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.payrollLoanReadDocument(checked));
}
const checkCheckedDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.payrollLoanCheckBoxCheckedDocument(checked));

}
const validateUploads = (errorFlow) => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().payrollLoanRequest;
    const recordStatus = immPayrollLoanRequest.get('preApprovalState');
    const immUpload = immPayrollLoanRequest.get('upload');

    const irpfFileWasLoaded = immUpload.getIn([IRPF_FILE, 'loaded']);
    const payrollLoanCertificateLoaded = immUpload.getIn([PAYROLL_LOAN_CERTIFICATE, 'loaded']);

    const immOutcome = immPayrollLoanRequest.get('outcome');
    const files = immPayrollLoanRequest.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
    const aditionalExpensesFileLoaded = files.first().get('loaded');

    const submitValidationErrorText = 'payrollLoanRequestStepThree-uploadSubmitValidationText';

    const errorHandler = (uploadName, message, idx = FILE_FIRST_INDEX) => {
        dispatch(simpleActions.payrollLoanRequestUploadFileError({ uploadName, message, idx }));
    }

    if (!irpfFileWasLoaded) {
        errorHandler(IRPF_FILE, submitValidationErrorText);
    }

    if (!payrollLoanCertificateLoaded) {
        errorHandler(PAYROLL_LOAN_CERTIFICATE, submitValidationErrorText);
    }

    let allFilesValid = true;
    if (recordStatus === ERROR_DOCUMENTACION) {
        files.forEach(immFile => {
            if (immFile.get('documentId') && immFile.get('notValid')) {
                dispatch(simpleActions.payrollLoanRequestUploadFileInvalidError({ idx: immFile.get('idx') }));
                allFilesValid = false;
            }

            return true;
        });
    }

    const aditionalExpensesValidate = haveExpenses(immOutcome) && !aditionalExpensesFileLoaded;
    if (aditionalExpensesValidate) {
        errorHandler(ADITIONAL_EXPENSES_FILES, submitValidationErrorText, files.first().get('idx'));
    }

    else if (irpfFileWasLoaded && payrollLoanCertificateLoaded && !aditionalExpensesValidate && allFilesValid) {
        dispatch(checkIfAllFilesWereUploaded(errorFlow));
    }
}
const getPayrollLoanINE = () => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().payrollLoanRequest;
    const operationProcessId = immPayrollLoanRequest.get('payrollInitOperationProcessId')
    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${retailLoanCommons.NEW_RETAIL_LOAN_PRECONTRACTUAL}/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            dispatch(simpleActions.getPayrollLoanIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));
        })
        .catch(() => {
            dispatch(simpleActions.getPayrollLoanIneDocumentError());
        });


}

const getInitParams = () => (dispatch, getState) => {
    const accounts = getState().accounts;
    const immPayrollLoan = getState().payrollLoanRequest;
    const selectedAccount = immPayrollLoan.get('selectedAccount');
    const immAccount = accounts.getIn(['byId', selectedAccount, 'iban']);
    const endOfMonth = immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const financedCommission = immPayrollLoan.get('indCapson') === amortizationTypes.YES ?
        FINANCIADA : NO_FINANCIADA;
    const immProposition = immPayrollLoan.get('proposition');
    const proccesTypeContract = retailLoanCommons.NEW_RETAIL_LOAN_PRECONTRACTUAL
    const standard = immPayrollLoan.get('productStandard');
    const subType = immPayrollLoan.get('productSubType');
    const type = immPayrollLoan.get('productType');

    return {
        query:
        {
            account: immAccount || 0,
            amount: formatAmount(immPayrollLoan.get('selectedAmount'), 'es'),
            calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee'), 'es'),
            capitalizedOpeningCommissionIndicator: immPayrollLoan.get('indCapson'),
            contractNumberAccount: 0,
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: endOfMonth,
            financedCommission: financedCommission,
            firstTime: true,
            loanPurpose: immPayrollLoan.get('selectedPurposeDrago'),
            processType: proccesTypeContract,
            product: {
                standard: STANDARD,
                subType: SUBPRODUCT,
                type: PRODUCT,
            },
            productDuration: immPayrollLoan.get('selectedTerm').toString(),
            productType: PRODUCT_TYPE,
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber', 0),
            tin: immPayrollLoan.get('tin'),
            tae: formatAmount(immPayrollLoan.get('tae'), 'es', 2),
            term: immPayrollLoan.get('selectedTerm'),
            year: immProposition.get('propositionYear'),
        }
    }
}
const getInitPayrollLoanINE = () => (dispatch) => {
    const params = dispatch(getInitParams());
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(simpleActions.payrollLoanInitIneSuccess({ payrollInitOperationProcessId: response.operationProcessId }));
            dispatch(getPayrollLoanINE())
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanInitIneError());
            } else {
                throw response;
            }
        });
}
const sendPayrollLoanSimpleEmail = () => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;
    const operationProcessId = immPayrollLoan.get('payrollInitOperationProcessId')
    const scrollDown = immPayrollLoan.get('scrollDown')
    const textOfficine = formatText(translationContractLoanPdfViewerINE.SIMPLE_EMAIL)
    const acceptanceText = isPrintOfficeMode() ? textOfficine : formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX)
    const params = {
        query: {
            mailType: retailLoanCommons.NEW_RETAIL_LOAN_PRECONTRACTUAL,
            documentId: operationProcessId,
            product: {
                standard: STANDARD,
                subType: SUBPRODUCT,
                type: PRODUCT,
            },
            contractNumberAccount: 0,
            operationProcessId,
            acceptanceText,
            scrollDown,
            expedientId: immPayrollLoan.get("recordId")
        }
    };

    APIPost({
        dispatch,
        endpoint: 'sendOverDraftSimpleEmail',
        params
    })
        .then(() => {
            dispatch(simpleActions.payrollLoanEmailSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanEmailError());

            } else {
                throw response;
            }
        });
};
const getPayrollLoanExpedientINE = () => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    const documentType = retailLoanCommons.NEW_RETAIL_LOAN_PRECONTRACTUAL
    const params = {
        header: {
            version: 2
        },
    }
    return APIGet(dispatch, `${apiURLBuilder.getURL('recoverFileDocument')}/${documentType}/${recordId}`, params)
        .then((response) => {
            dispatch(simpleActions.getContractPayrollLoanExpedientIneSuccess({ response }));
            return response
        })
        .catch((response) => {
            dispatch(simpleActions.getContractPayrollLoanExpedientIneError());
            return response

        });

}
const contractInitialize = () => (dispatch) => {
    return APIGet({ dispatch, endpoint: 'contractLoanInitialize' })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestInitializeFlowSuccess({ response }));

        })
};
const validateStep = currentStep => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().payrollLoanRequest;
    const immPLoanRecordStatus = getState().loanRecordStatus.get('state')
    const changeStatusINE = immPayrollLoanRequest.get('changeStatusINE');
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const newPersonalLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);
    const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
    if (newPersonalLoanFF) {
        if (immPLoanRecordStatus === 'APORTAR_DOC') {
            dispatch(getPayrollLoanExpedientINE())
                .then((response) => {
                    const expedientOperationProcessId = response.operationProcessId

                    if (currentStep === WIZARD_FOURTH_STEP) {
                        dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep: 4, isDragoFeature, newPersonalLoanFF }));

                    } else if (currentStep === WIZARD_FIFTH_STEP) {
                        if (!__CONTACT_CENTER__ || isPrintOfficeMode()) {
                            dispatch(validateUploads());
                        } else {
                            dispatch(simpleActions.payrollLoanRequestFinishWithoutUpload());
                            return true;
                        }
                    } else {

                        if (!expedientOperationProcessId) {
                            dispatch(initializeFlow())
                                .then(() => dispatch(requestLoanApproval()))
                                .then(() => dispatch(getProposition()))
                                .then(() => dispatch(getInitPayrollLoanINE()))
                            dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep: 3, isDragoFeature, newPersonalLoanFF }))

                        } else if (expedientOperationProcessId) {
                            dispatch(contractInitialize())
                            dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep: 4, isDragoFeature, newPersonalLoanFF }));

                        }
                    }
                })

        } else {
            if (currentStep === WIZARD_THIRD_STEP) {
                if (changeStatusINE) {
                    dispatch(getInitPayrollLoanINE())
                }
                dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep: 3, isDragoFeature, newPersonalLoanFF }));

            } else if (currentStep === WIZARD_FOURTH_STEP) {
                dispatch(sendPayrollLoanSimpleEmail())
                dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep: 4, isDragoFeature, newPersonalLoanFF }));

            } else if (currentStep === WIZARD_FIFTH_STEP) {
                if (!__CONTACT_CENTER__ || isPrintOfficeMode()) {
                    dispatch(validateUploads());
                } else {
                    dispatch(simpleActions.payrollLoanRequestFinishWithoutUpload());
                    return true;
                }
            } else {
                dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep, isDragoFeature, newPersonalLoanFF }));
            }
        }


    } else {
        if (currentStep - 1 === WIZARD_THIRD_STEP) {
            if (!__CONTACT_CENTER__ || isPrintOfficeMode()) {
                dispatch(validateUploads());
            } else {
                dispatch(simpleActions.payrollLoanRequestFinishWithoutUpload());
                return true;
            }
        } else {
            const immFlagBasedFeatures = getState().flagBasedFeatures;
            const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
            if (currentStep >= 2) {
                dispatch(getAsnefValidation());
            }
            dispatch(simpleActions.payrollLoanRequestValidateStep({ currentStep, isDragoFeature }));
        }

    };
}
const finishBtnUploadDocumentsFlow = () => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().payrollLoanRequest;
    const recordStatus = immPayrollLoanRequest.get('preApprovalState');
    const errorFlow = recordStatus === ERROR_DOCUMENTACION;

    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
        dispatch(simpleActions.payrollLoanRequestFinishWithoutUpload());
    } else {
        dispatch(validateUploads(errorFlow));
    }
}

const getLoansForExpenses = (save = true) => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;
    const immLoan = getState().loans;

    const loansInformation = immLoan.get('loansByOrder');
    const mortgagesInformation = immLoan.get('mortgagesByOrder');
    const loansById = immLoan.get('byId');

    const loansAndMortgages = loansInformation.concat(mortgagesInformation);
    const loansAndMortgagesValues = loansAndMortgages.map(id => {
        const loanData = loansById.find(loan => loan.get('loanId') === id);
        return {
            'newContractNumber': loanData.get('newContractNumber'),
            'productName': loanData.get('alias').trim(),
            'productType': loanData.get('newProduct')
        }
    });

    const params = {
        query: {
            loans: loansAndMortgagesValues.toArray()
        }
    };

    dispatch(simpleActions.payrollLoanRequestGetLoansForExpenses());
    return APIPost({ dispatch, endpoint: 'loans', params })
        .then(response => {
            const informationLoans = get(response, 'loans', []);

            let subMortgages = immPayrollLoan.getIn(['outcome', 'mortgage']) || 0;
            let subOtherLoansInstallments = immPayrollLoan.getIn(['outcome', 'others']) || 0;

            informationLoans.map(item => {
                const loanFullInfo = loansById.find(loan => loan.get('contractNumber') === item.newContractNumber);
                if (loanFullInfo.get('isMortgage')) {
                    subMortgages = subMortgages.toFixed(2) - parseFloat(item.monthlyFee);
                } else {
                    subOtherLoansInstallments = subOtherLoansInstallments.toFixed(2) - parseFloat(item.monthlyFee);
                }
            });

            const outcome = {
                rent: immPayrollLoan.getIn(['outcome', 'rent']),
                mortgage: subMortgages < 0 ? 0 : subMortgages,
                others: subOtherLoansInstallments < 0 ? 0 : subOtherLoansInstallments
            }

            dispatch(simpleActions.payrollLoanRequestGetLoansForExpensesSuccess({ response }));
            dispatch(setOutcome(outcome, save));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestGetLoansForExpensesError({ error: response.error }));
            } else {
                throw response;
            }
        });
}

const buildValidName = (fullName, receiptDefaultName) => {
    const fileName = fullName.split('.')[0];
    const validateText = ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEX.test(fileName);
    if (!validateText) {
        const validName = fileName.replace(REGEX_REMOVE_SPECIAL_SYMBOLS, '');
        return validName !== "" ? validName : receiptDefaultName;
    }
    return fileName;
}

const getDocumentType = (uploadName) => {
    let documentType;
    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        documentType = RECEIPT;
    } else if (uploadName === PAYROLL_LOAN_CERTIFICATE) {
        documentType = NOM_VL;
    } else {
        documentType = IRPF100;
    }
    return documentType;
}

const editNameFilesForPersonalLoan = (parameters) => (dispatch, getState) => {
    const immLoanRecordStatus = getState().loanRecordStatus;
    const immPayrollLoan = getState().payrollLoanRequest;
    const recordStatus = immLoanRecordStatus.get('state');
    const recordId = recordStatus === DENEGADO_ANTES_PREAPROB ? immPayrollLoan.get('recordId') : immLoanRecordStatus.get('recordId');
    const { response: { nameFile, typeFile, documentId, idx, receiptDefaultName } } = parameters;
    const query = new FormData();
    const documentType = getDocumentType(typeFile);
    const documentName = nameFile !== "" ? nameFile : receiptDefaultName;

    query.append(
        'request',
        new Blob([JSON.stringify({
            documentType,
            recordId,
            documentName,
            documentId: documentId
        })],
            { type: 'application/json' })
    );

    const params = {
        header: {
            version: VERSION_2
        },
        query
    };
    dispatch(simpleActions.payrollLoanRequestEditNameFile({ uploadName: typeFile, idx }));
    return APIPost({ dispatch, endpoint: 'payrollLoanUploadFile', params, contentType: false })
        .then(() => {
            const response = Object.assign({}, parameters.response, { nameFile: documentName });
            dispatch(simpleActions.payrollLoanRequestEditNameFileSuccess({ response }));
        }).catch(() => {
            dispatch(simpleActions.payrollLoanRequestEditNameFileError({ uploadName: typeFile, message: messageDeleteOrChangeNameErrorText, idx }));
        });
}

const uploadFilesForPersonalLoan = (parameters) => (dispatch, getState) => {
    const immLoanRecordStatus = getState().loanRecordStatus;
    const immPayrollLoan = getState().payrollLoanRequest;
    const recordStatus = immLoanRecordStatus.get('state');
    const recordId = recordStatus === DENEGADO_ANTES_PREAPROB ? immPayrollLoan.get('recordId') : immLoanRecordStatus.get('recordId');

    const { response: { file, uploadName, idx, receiptDefaultName, messageSnackSuccess } } = parameters;
    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        parameters.newName = buildValidName(get(file, 'name', ''), receiptDefaultName);
    } else if (uploadName === PAYROLL_LOAN_CERTIFICATE) {
        parameters.newName = getTranslatedDocumentName(NOM_VL);
    } else {
        parameters.newName = getTranslatedDocumentName(IRPF100);
    }
    const documentType = getDocumentType(uploadName);

    const query = new FormData();
    query.append('file', file);

    query.append(
        'request',
        new Blob([JSON.stringify({
            documentType,
            recordId,
            documentName: parameters.newName
        })],
            { type: 'application/json' })
    );

    const params = {
        header: {
            version: VERSION_2
        },
        query
    };
    dispatch(simpleActions.payrollLoanRequestUploadFile({ uploadName, idx }));
    return APIPost({ dispatch, endpoint: 'payrollLoanUploadFile', params, contentType: false })
        .then(response => {
            if (uploadName == ADITIONAL_EXPENSES_FILES) {
                parameters.documentId = response.data;
            }
            dispatch(notificationActions.success({ message: messageSnackSuccess }, { voice: messageSnackSuccess }));
            dispatch(simpleActions.payrollLoanRequestUploadFileLoad(parameters));
        }).catch(() => {
            dispatch(simpleActions.payrollLoanRequestUploadFileError({ uploadName, message: messageUploadExternalErrorText, idx }));
        });
}

const removeFileForPersonalLoan = (parameters) => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    const { idx, documentId, uploadName } = parameters;
    const documentType = getDocumentType(uploadName);
    const params = {
        query: {
            recordId,
            documentId,
            documentType
        }
    };
    dispatch(simpleActions.payrollLoanRequestUploadFileRemove({ uploadName, idx }));
    return APIPost({ dispatch, endpoint: 'deletePersonalLoansDocument', params })
        .then(() => {
            dispatch(simpleActions.payrollLoanRequestUploadFileRemoveSuccess({ response: parameters }));
        }).catch(() => {
            dispatch(simpleActions.payrollLoanRequestUploadFileRemoveError({ uploadName, message: messageDeleteOrChangeNameErrorText, idx }));
        });
}

const clearErrors = (parameters) => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().payrollLoanRequest;
    const recordStatus = immPayrollLoanRequest.get('preApprovalState');
    const { idx, uploadName } = parameters;

    if (recordStatus === ERROR_DOCUMENTACION && uploadName === ADITIONAL_EXPENSES_FILES) {
        const immFiles = immPayrollLoanRequest.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
        const immFile = immFiles.find(immFile => immFile.get('idx') === idx);

        if (immFile && immFile.get('notValid')) {
            return dispatch(removeFileForPersonalLoan(parameters));
        }
    }
    return dispatch(simpleActions.payrollLoanRequestClearErrorsFile(parameters));
}

const setSubpurpose = response => (dispatch, getState) => {
    const immPayrollLoan = getState().payrollLoanRequest;
    const purpose = immPayrollLoan.get('selectedPurposeDrago');
    const subpurpose = response.value;
    recordLink(PAGE_LOANS_MORTGAGES, `proposito ${purpose}`, subpurpose);
    dispatch(simpleActions.payrollLoanRequestSetSubpurpose({ subpurpose }));
    dispatch(payrollLoanSaveInProgress());
}

const getPersonalInformation = () => dispatch => {
    dispatch(simpleActions.payrollLoanRequestGetPersonalInfo());
    APIGet({ dispatch, endpoint: 'payrollLoanGetPersonalInfo' })
        .then(response => {
            dispatch(simpleActions.payrollLoanRequestGetPersonalInfoSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestGetPersonalInfoError());
            } else {
                throw response;
            }
        });
}


const downloadPreContractDocument = () => dispatch => {
    const params = {
        query: {
            estandar: STANDARD,
            subtipo: SUBPRODUCT,
            tipo: PRODUCT,
            idioma: retailLoanCommons.LANGUAGE_ID
        }
    };
    dispatch(simpleActions.payrollLoanRequestDownloadPrecontractualIne());
    APIGet({ dispatch, endpoint: 'requestPreContractActive', params }).then(response => {
        const pdfUrl = get(response, 'response[0].url');
        if (!!pdfUrl) {
            window.open(pdfUrl);
        }
        dispatch(simpleActions.payrollLoanRequestDownloadPrecontractualIneSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.payrollLoanRequestDownloadPrecontractualIneError());
        });
};

const recoveryProcessType = () => dispatch => {
    dispatch(simpleActions.payrollLoanRequestRecoveryProcessType())
};

const getAsnefValidation = (currentStep) => (dispatch, getState) => {
    const isDragoFeature = getState().flagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
    const params = {
        query: {
            productType: ASNEF_PRODUCT,
            productSubType: ASNEF_SUBPRODUCT,
            productStandard: ASNEF_STANDARD,
        }
    };
    dispatch(simpleActions.payrollLoanRequestAsnef());

    return APIGet({ dispatch, endpoint: 'asnefValidation', params })
        .then(response => {
            if (response.response === ASNEFKO) {
                dispatch(simpleActions.payrollLoanRequestAsnefFailure());
            } else {
                dispatch(simpleActions.payrollLoanRequestAsnefSuccess({ currentStep, isDragoFeature }));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestAsnefError());
            } else {
                throw response;
            }
        });
};

const printDocumentOffice = () => (dispatch, getState) => {
    dispatch(simpleActions.payrollLoanRequestPrintDocumentOffice())
};
const checkRadioButtonOffice = (check) => (dispatch, getState) => {
    dispatch(simpleActions.payrollLoanRequestCheckRadioButton(check));
};
module.exports = {
    actionApprovalLetter,
    changeViewPreApprovalKOxDTI,
    clearErrors,
    downloadINEDocument,
    downloadPreContractDocument,
    editNameFilesForPersonalLoan,
    finishBtnUploadDocumentsFlow,
    getAsnefValidation,
    getInstallment,
    getJobsInformation,
    getLoansForExpenses,
    getMinTerm,
    getPersonalInformation,
    getProposition,
    initialize,
    loadFilesPersonalLoan,
    payrollLoanSaveInProgress,
    recoveryProcessType,
    removeFileForPersonalLoan,
    requestLoanApproval,
    resetStep,
    sentPrecontractualEmail,
    setCivilStatus,
    setCompanyMonths,
    setCompanyYears,
    setContractType,
    setCreditCard,
    setEmploymentLevel,
    setIncome,
    setJob,
    setLoanAmount,
    setLoanAmountKOxDTI,
    setLoanTerm,
    setLoanTermKOxDTI,
    setNewJobType,
    setOutcome,
    setPurpose,
    setRegime,
    setSubpurpose,
    setWorkingTimeWrapper,
    setWorkingTimeWrapperFocus,
    simpleActions,
    uploadFilesForPersonalLoan,
    validateAmountKOxDTI,
    validateStep,
    validateUploads,
    checkReadDocument,
    checkCheckedDocument,
    sendPayrollLoanSimpleEmail,
    checkRadioButtonOffice,
    printDocumentOffice
};
